<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  groups: { type: Array, default: () => [] },
});

const formatValue = value =>
  new Intl.NumberFormat('pt-BR', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(Number(value || 0));
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section class="grid gap-4">
    <article
      v-for="group in groups"
      :key="group.key"
      class="rounded-lais border border-lais-border bg-white p-4 shadow-lais-card"
    >
      <div class="flex items-center gap-2">
        <span
          class="grid size-8 place-items-center rounded-full bg-lais-primary-50 text-lais-primary"
          aria-hidden="true"
        >
          <span class="size-4" :class="group.icon" />
        </span>
        <h3 class="text-[16px] font-semibold text-lais-text">
          {{ group.title }}
        </h3>
      </div>
      <div class="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        <div
          v-for="metric in group.metrics"
          :key="metric.label"
          class="rounded-lais border border-lais-border-soft bg-lais-bg-soft px-4 py-3"
        >
          <p class="text-[24px] font-semibold text-lais-text">
            {{ formatValue(metric.value) }}
          </p>
          <p class="mt-1 text-[12px] font-semibold text-lais-text-muted">
            {{ metric.label }}
          </p>
        </div>
      </div>
    </article>
  </section>
</template>
